import React, {useState, useEffect} from 'react';
import {Grid , Chip, Typography, List, ListItem, ListItemIcon, ListItemText, Divider, Paper} from '@material-ui/core/';
import {NavigateNext} from '@material-ui/icons';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {AccountCircle, Email, Filter1, Today, LocationOn, Call, Wc, Person, InsertComment, Description, HomeWork } from '@material-ui/icons';

function DatosDelDPI(props) {   
    const classes = useStyles()
    const [datosCiudadanoTable, setdatosCiudadanoTable] = useState({
        cui:0,
        fechaEmisionDpi:'',
        serieDpi: 0,
        lugarVecindad:'',
        munCedulaRef:0,
        // departamentoCedula:'',
        lugarExtCedula:'',

    });
    const splitDate = (date) => {
        if (date !== undefined) {
            var arr1 = date.split("-");
            if(arr1[2] !== undefined){
                var arr2 = arr1[2].split("T");
                var finalDate = arr2[0] + "/" + arr1[1] + "/" + arr1[0];
            }
            return finalDate;
          }
    };
    useEffect(() => {
        if(JSON.stringify(props.datosCiudadanoTable)!=='{}'){
            var departamentoVecindad = '', municipioVecindad = '',
                departamentoCedula = '',
                municipioCedula = '',
                noCedula = '';
            // lugar de vecindad
            if(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.departamentoVecindad === null) departamentoVecindad = '';
            else departamentoVecindad= props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.departamentoVecindad.name
            if(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.municipioVecindad === null) municipioVecindad = '';
            else municipioVecindad= props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.municipioVecindad.name

            //ñigar extensión de cedula
            if(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.departamentocedula === null) departamentoCedula= ''
            else departamentoCedula = props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.departamentocedula.name
            if(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.municipioCedula === null) municipioCedula= ''
            else municipioCedula = props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.municipioCedula.name

            //no de cedula
            if(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.ordenCedulaRef === null) noCedula = ''
            else noCedula = props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.ordenCedulaRef+'-'+props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.registroCedulaRef

            setdatosCiudadanoTable({
                cui: props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.cui,
                fechaEmisionDpi: props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.fechaEmisionDpi,
                serieDpi: props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento.serieDpi,
                lugarVecindad: departamentoVecindad +', '+municipioVecindad,
                lugarExtCedula: departamentoCedula+', '+municipioCedula,
                munCedulaRef: noCedula,
            })            
        
        }
    },[props.datosCiudadanoTable])
    return (
        <Grid container >
            <Grid item xs={12}>
                <div className={classes.centerTitle}><Divider /> <strong>DATOS DEL DPI</strong> <Divider /></div>
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="CUI del DPI: " />
                    <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                </ListItem>
            </Grid >                
            <Grid item xs={3}>
                <Chip className={classes.colorChip} label={datosCiudadanoTable.cui} />                                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Fecha de emisión del DPI: " />
                    <ListItemIcon className={classes.colorIcon}><Today/></ListItemIcon>
                </ListItem>
            </Grid >                
            <Grid item xs={3}>
                <Chip className={classes.colorChip} label={splitDate(datosCiudadanoTable.fechaEmisionDpi)} />                                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="No. Serie: " />
                    <ListItemIcon className={classes.colorIcon}><Filter1/></ListItemIcon>
                </ListItem>
            </Grid >                
            <Grid item xs={3}>
                <Chip className={classes.colorChip} label={datosCiudadanoTable.serieDpi} />                                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Lugar de Vecindad: " />
                    <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                </ListItem>
            </Grid >                
            <Grid item xs={3}>
                <Chip className={classes.colorChip} label={datosCiudadanoTable.lugarVecindad}/>
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="No. Cédula: " />
                    <ListItemIcon className={classes.colorIcon}><Filter1/></ListItemIcon>
                </ListItem>
            </Grid >                
            <Grid item xs={3}>
                <Chip className={classes.colorChip} label={datosCiudadanoTable.munCedulaRef} />                                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Lugar Ext. de Cédula: " />
                    <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                </ListItem>
            </Grid >             
            <Grid item xs={3}>
                <Chip className={classes.colorChip} label={datosCiudadanoTable.lugarExtCedula} />                                
            </Grid >             
        </Grid>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(DatosDelDPI);